import { useNavigate } from "react-router-dom";
import { SaveIcon } from "../../../../assets/icons";
import { FallbackImage } from "../../../../assets/img";
import Modal from "../../../../components/ui/Modal/Modal";
import { Pagination } from "../../../../components/ui/Table/Pagination/Pagination";
import InventoryDetail from "./InventoryDetail";

export default function FactoryInventoryTable() {
  const navigate = useNavigate();

  const table = {
    row: [
      {
        no: "10",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "미연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <Modal
            widthSubmitButton="w-auto px-4"
            submitText="스마트팩토리 재고 연동 완료"
            description={
              <span>
                해당 상품을 입고수량으로 연동하시겠습니까?
                <br />
                최종적으로 입고수량이 맞는 지 확인하신 후, 연동하기를
                눌러주세요.
                <br />
                연동하게 되면 재고가 등록되어, 관련된 총 입고수량, 당일 재고, 총
                재고에 모두 연동됩니다.
              </span>
            }
          >
            <button
              type="button"
              className="cursor-pointer py-1 text-[10px] px-[0.5rem] bg-[#ad0000] border border-[#ad0000] rounded-[4px] text-white"
            >
              API 연동하기
            </button>
          </Modal>
        ),
      },
      {
        no: "9",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            disabled
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "8",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "7",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "6",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "5",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "4",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "3",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "2",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
      {
        no: "1",
        sort: "스마트팩토리 연동",
        apiStatus: "미연동",
        stockStatus: "연동",
        category: "Category 1",
        ref: "REFCODE01",
        lotNo: (
          <div>
            LOTtestCode0 <br />
            0000001
          </div>
        ),
        manufacDate: "2022-01-02",
        expireDate: "2022-01-02",
        qty: "100",
        lastUpdated: "2022-01-01",
        action: (
          <button
            onClick={() => {}}
            className="py-1 px-[0.5rem] text-[10px] bg-[#dddddd] border border-[#dddddd] rounded-[4px] text-[#555555]"
            disabled
          >
            API 연동하기
          </button>
        ),
      },
    ],
    header: [
      {
        id: 1,
        title: <div className="font-light">번호</div>,
      },
      {
        id: 2,
        title: <div className="font-light">구분</div>,
      },
      {
        id: 3,
        title: (
          <div>
            API
            <br />
            연동여부
          </div>
        ),
      },
      {
        id: 4,
        title: (
          <div className="font-light">
            재고
            <br />
            연동여부
          </div>
        ),
      },
      {
        id: 5,
        title: <div className="font-light">카테고리</div>,
      },
      {
        id: 6,
        title: <div className="font-light">REF(상품코드)</div>,
      },
      {
        id: 7,
        title: <div className="font-light">LOT</div>,
      },

      {
        id: 11,
        title: <div className="font-light">제조일자</div>,
      },

      {
        id: 12,
        title: <div className="font-light">유효일자</div>,
      },

      {
        id: 13,
        title: <div className="font-light">입고수량</div>,
      },
      {
        id: 14,
        title: <div className="font-light">최종 업데이트일</div>,
      },
      {
        id: 14,
        title: <span>API 연동관리</span>,
      },
    ],
  };
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val, index) => (
                <th
                  className={`${
                    index - 5 && index - 10
                      ? "border"
                      : "border-r-[3px] border-r-border-grey"
                  } px-2 py-0.5 bg-[#f2f2f4] border-[#dddddd]`}
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {table.row.map((row, idx) => (
              <>
                <tr
                  className={` ${
                    row?.stockStatus === "미연동" ? "bg-[#fff7c1]" : ""
                  }`}
                  key={idx}
                >
                  <td className="px-3 border border-[#dddddd]">{row?.no}</td>
                  <td className="px-3 border border-[#dddddd]">{row?.sort}</td>
                  <td className="px-3 border border-[#dddddd]">
                    {row?.apiStatus}
                  </td>
                  <td className="px-3 border border-[#dddddd]">
                    <span
                      className={`${
                        row?.stockStatus === "미연동" ? "text-[#FF0000]" : ""
                      }`}
                    >
                      {row?.stockStatus}
                    </span>
                  </td>
                  <td className="px-3 border border-[#dddddd]">
                    {row?.category}
                  </td>
                  <td className="p-3 border border-r-border-grey border-r-[3px] border-[#dddddd]">
                    {row?.ref}
                  </td>
                  <td className="px-3 border border-[#dddddd]">{row?.lotNo}</td>
                  <td className="px-3 border border-[#dddddd]">
                    {row?.manufacDate}
                  </td>
                  <td className="px-3 border border-[#dddddd]">
                    {row?.expireDate}
                  </td>
                  <td className="px-3 border border-[#dddddd]">{row?.qty}</td>
                  <td className="px-3 border border-r-border-grey border-r-[3px] border-[#dddddd]">
                    {row?.lastUpdated}
                  </td>
                  <td className="px-3 border border-[#dddddd]">
                    {row?.action}
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-8 flex justify-center overflow-auto w-full">
        <Pagination
          total={1}
          page={0}
          isDisabledPrevPage={false}
          isDisabledNextPage={false}
          onPrevClick={() => {}}
          onNextClick={() => {}}
          onChange={() => {}}
        />
        <div className="flex-none">
          <Modal
            hasCancel={false}
            description="다운로드 되었습니다."
            onSubmit={() => {}}
          >
            <button className="p-[10px] border border-[#cccccc] rounded-[4px] text-[#333333]">
              <div className="flex h-2 items-center gap-2">
                <SaveIcon />
                엑셀 저장
              </div>
            </button>
          </Modal>
        </div>
      </div>
    </>
  );
}
